export default "__VITE_ASSET__BzXMj7sT__"